import cx from 'classnames';
import React from 'react';

import * as styles from './Columns.module.css';

const Columns = ({
	children,
	align,
	stretch,
	constrain,
	className = '',
	deep,
}: {
	children: React.ReactNode;
	align?: 'top' | 'center' | 'bottom' | 'stretch';
	stretch?: boolean;
	constrain?: boolean;
	className?: string;
	deep?: boolean;
}) => {
	return (
		<div
			className={cx(styles.columns, className, {
				[styles.constrain]: constrain,
				[styles.stretch]: stretch,
				[styles.deep]: deep,
			})}>
			{children.map((child: string, key: number) => (
				<div
					className={cx(styles.column, styles[align], {
						[styles.constrain]: constrain,
					})}
					key={key}>
					{child}
				</div>
			))}
		</div>
	);
};

export default Columns;
